module.exports = __webpack_public_path__ + "img/SCC_CD8T.41e17d70.png";